export const dateRangeOptions = [
  {
    value: 'lastDay',
    label: 'Last Day',
  },
  {
    value: 'last7Days',
    label: 'Last 7 Days',
  },
  {
    value: 'last28Days',
    label: 'Last 28 Days',
  },
  {
    value: 'last3Months',
    label: 'Last 3 Months',
  },
  {
    value: 'last6Months',
    label: 'Last 6 Months',
  },
  {
    value: 'last12Months',
    label: 'Last 12 Months',
  },
];

export const groupByOptions = [
  {
    value: 'daily',
    label: 'Daily',
  },
  {
    value: 'monthly',
    label: 'Monthly',
  },
];

export const productionEnvironmentOptions = [
  {
    value: 'PROD_FILTER',
    label: 'Production',
  },
  {
    value: 'ALL_ACCOUNTS_FILTER',
    label: 'All Accounts',
  },
  // Commenting these out as they are not required as of yet
  // Will be used in future implementations
  // when we implement orchestrator and habu managed filters using tags
  // {
  //   value: 'HABU_MANAGED_FILTER',
  //   label: 'Habu Managed',
  // },
  // {
  //   value: 'ORCHESTRATOR_FILTER',
  //   label: 'Orchestrator',
  // },
  // {
  //   value: 'PROD_AND_HABU_MANAGED_FILTER',
  //   label: 'Production & Habu Managed',
  // },
  // {
  //   value: 'PROD_ORCHESTRATOR_FILTER',
  //   label: 'Production Orchestrator',
  // },
  // {
  //   value: 'PROD_AND_STAGE_FILTER',
  //   label: 'Production & Stage',
  // },
];

export const stagingEnvironmentOptions = [
  {
    value: 'STAGE_FILTER',
    label: 'Stage',
  },
  {
    value: 'DEV_FILTER',
    label: 'Development',
  },
  {
    value: 'DEV_AND_STAGE_FILTER',
    label: 'Development & Stage',
  },
  // {
  //   value: 'DEV_AND_HABU_MANAGED_FILTER',
  //   label: 'Development & Habu Managed',
  // },
  // {
  //   value: 'STAGE_AND_HABU_MANAGED_FILTER',
  //   label: 'Stage & Habu Managed',
  // },
  // {
  //   value: 'DEV_ORCHESTRATOR_FILTER',
  //   label: 'Development Orchestrator',
  // },
  // {
  //   value: 'STAGE_ORCHESTRATOR_FILTER',
  //   label: 'Stage Orchestrator',
  // },
];
